// Author Lin
// Date 2021-11-02 14:03:34

class MintalMesInventoryQuantityAdjustment {
    constructor({
            id = null,
            materialQuantityId = '',
            adjustTime = '',
            beforeAdjust = '',
            afterAdjust = '',
            adjustmentAmount = '',
            inventoryResult = '',
            adjustmentUser = '',
            reviewer = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.materialQuantityId = materialQuantityId;
        this.adjustTime = adjustTime;
        this.beforeAdjust = beforeAdjust;
        this.afterAdjust = afterAdjust;
        this.adjustmentAmount = adjustmentAmount;
        this.inventoryResult = inventoryResult;
        this.adjustmentUser = adjustmentUser;
        this.reviewer = reviewer;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesInventoryQuantityAdjustment();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialQuantityId',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.materialQuantityId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialName',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.materialName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialCode',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.materialCode',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.warehouseName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'adjustTime',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.adjustTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'beforeAdjust',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.beforeAdjust',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'afterAdjust',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.afterAdjust',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'adjustmentAmount',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.adjustmentAmount',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'inventoryResult',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.inventoryResult',
            sortable: true,
            form: {
            type: 'select'
            ,options: [
                    { value: '1', text: '盘盈' },
                    { value: '2', text: '盘亏' },
                    { value: '3', text: '持平'}
                ]
            }
            },
            {
            key: 'adjustmentUser',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.adjustmentUser',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'adjustmentUserName',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.adjustmentUserName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.reviewer',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewerName',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.reviewerName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        materialQuantityIdFilter : '',
        adjustTimeRteFilter : '',
        adjustTimeLteFilter : '',
        beforeAdjustFilter : '',
        afterAdjustFilter : '',
        adjustmentAmountFilter : '',
        inventoryResultFilter : '',
        adjustmentUserFilter : '',
        reviewerFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'materialQuantityIdFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.materialQuantityId',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesInventoryMaterialQuantity'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'adjustTimeRteFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.adjustTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'adjustTimeLteFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.adjustTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'inventoryResultFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.inventoryResult',
            disabled: false,
            form: {
            type: 'select'
                ,showLabelSelectOne: true
             ,options: [
                { value: '1', text: '盘盈' },
                { value: '2', text: '盘亏' },
                { value: '3', text: '持平'}
                ]
            }
            },
            {
            key: 'adjustmentUserFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.adjustmentUser',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'reviewerFilter',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.filter.reviewer',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'materialQuantityId',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.materialQuantityId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesInventoryMaterialQuantity'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'adjustTime',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.adjustTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'beforeAdjust',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.beforeAdjust',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'afterAdjust',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.afterAdjust',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'adjustmentAmount',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.adjustmentAmount',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'inventoryResult',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.inventoryResult',
            sortable: true,
            disabled: false,
            form: {
            type: 'select'
                ,showLabelSelectOne: true
            ,options: [
                { value: '1', text: '盘盈' },
                { value: '2', text: '盘亏' },
                { value: '3', text: '持平'}
                ]
            }
            },
            {
            key: 'adjustmentUser',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.adjustmentUser',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.reviewer',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryQuantityAdjustment.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesInventoryQuantityAdjustment, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    